module.exports = __webpack_public_path__ + "img/1.3b312012.png";